module.exports = __webpack_public_path__ + "img/roundtable.f7d415d6.png";